/** Interfaces */
import { DsFormInstanceAttachmentInterface } from '../interfaces/form-instance/ds-form-instance-attachment.interface';

export class DsFormTemplateAttachment implements DsFormInstanceAttachmentInterface {
  /**
   * The attachment id.
   */
  readonly id?: number;

  /**
   * The attachment name.
   */
  readonly name: string;

  /**
   * The attachment hash.
   */
  readonly hash: string;

  /**
   * Creates an instance of DsFormTemplateAttachment.
   *
   * @param jsonObject the form attachments data.
   */
  constructor(jsonObject: DsFormInstanceAttachmentInterface) {
    this.id = jsonObject.id;
    this.name = jsonObject.name;
    this.hash = jsonObject.hash;
  }
}
